import React from 'react'

const TermsOfService = () => {
  return (
    <div className="text-sm">
      <h1 className="text-lg font-bold">TERMS OF SERVICE</h1>
      <div>Last updated July 28, 2022</div>

      <div className="my-3">
        These Terms of Service (these "Terms" or the "Agreement") describe our
        company’s ("Company," "we," "us," or "our") terms of service with
        respect to persons or entities who access our property’s website (the
        "Site"), including without limitation renters and potential renters
        (collectively, with all persons or entities who access the Site,
        "Users," "you," or "your").
      </div>
      <div className="my-3">
        This Site is owned and operated by us to offer certain services to
        renters and potential renters (the "Services").
      </div>
      <div className="my-3">
        <span className="font-bold mr-2">
          IMPORTANT – PLEASE READ CAREFULLY.
        </span>
        THESE TERMS CONSTITUTE A LEGAL AGREEMENT BETWEEN YOU AND US. THIS
        AGREEMENT ALONG WITH ANY OTHER TERMS THAT MAY BE POSTED ON THE SITE, AND
        ANY OTHER WRITTEN AGREEMENTS OR CONTRACTS BETWEEN YOU AND US THAT
        INCORPORATE THESE TERMS BY REFERENCE, SET FORTH THE COMPLETE TERMS AND
        CONDITIONS UNDER WHICH YOU MAY ACCESS AND USE THE SITE AND THE SERVICES.
        IF YOU DO NOT AGREE TO THESE TERMS, YOU MAY NOT USE THE SITE OR THE
        SERVICES.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">1. YOUR ACCEPTANCE.</span>
        We are pleased to provide the Site and the Services conditioned upon
        your acceptance, and we hope that you will find the Site informative and
        useful. BY USING THE SITE, YOU EXPRESSLY ACCEPT AND CONSENT TO THESE
        TERMS WITHOUT QUALIFICATION. COMPANY MAY AMEND THESE TERMS FROM TIME TO
        TIME. SHOULD THESE TERMS BE MODIFIED IN ANY WAY, THE NEW TERMS WILL BE
        POSTED TO THIS WEBPAGE. BY USING THE SITE AFTER THE EFFECTIVE DATE OF
        ANY MODIFICATION TO THESE TERMS, YOU EXPRESSLY CONSENT, WITHOUT
        QUALIFICATION, TO THE MODIFIED TERMS.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">
          2. ACCESS TO AND USE OF THE SITE.
        </span>
        <ul>
          <li className="my-2">
            2.1 You are responsible for how you use the Site, and Company
            encourages anyone who accesses the Site, including Users, to
            exercise sound judgment when entering into property rental
            transactions.
          </li>
          <li className="my-2">
            2.2 We provide you with certain information and functionality
            through the Site. You are solely responsible for providing all
            equipment necessary to establish a connection to the Internet,
            access to the Internet, and any telephone, wireless or other
            connection and service fees associated with such access.
          </li>
          <li className="my-2">
            2.3 We have the right, but not the obligation, to take any of the
            following actions without providing any prior notice to you: (a)
            change or terminate all or any part of the Site or the Services; (b)
            restrict or terminate your access to all or any part of the Site or
            the Services; or (c) refuse, move, or remove any content that is
            available on the Site and any material that you submit to the Site.
          </li>
          <li className="my-2">
            2.4 Subject to your compliance with these Terms, we hereby grant you
            permission to access and use the Site and the Services, provided
            that you shall not (and shall not allow any third party to): (a)
            engage in commercial use of the Site or any content on the Site; (b)
            reproduce, copy, display, store, perform, re-post, publish,
            transmit, distribute, sell, offer for sale, license, modify, create
            derivative works, or otherwise use any portion of the content
            offered on the Site for other than your own personal, non-commercial
            use; (c) remove any copyright, trademark or other proprietary rights
            notices contained in or on the Site or Service or in or on any
            content or other material obtained via the Site or the Services; (d)
            use any robot, spider, site search/retrieval application, or other
            automated device, process or means to access, retrieve, scrape or
            index any portion of the Site or the Services, including, but not
            limited to, for purposes of constructing or populating a searchable
            database of business or property reviews; (e) collect or harvest any
            information about other users or members (including usernames and/or
            email addresses) for any purpose; (f) reformat or frame any portion
            of the web pages that are part of the Site or the Services; (g)
            create user accounts by automated means or under false, misleading
            or fraudulent pretenses; (h) create or transmit unwanted electronic
            communications such as "spam" to other users or members of the Site
            or the Services or otherwise interfere with other users’ or members’
            enjoyment of the Site or the Services; (i) transmit any viruses,
            worms, defects, Trojan horses or other items of a destructive
            nature; (j) use the Site or the Services to violate the security of
            any computer network, crack passwords or security encryption codes,
            transfer or store illegal material, including any material that may
            be deemed threatening or obscene; (k) copy or modify the HTML code
            used to generate web pages on the Site; (l) use any device, software
            or procedure that interferes with the proper working of the Site or
            the Services, or otherwise attempt to interfere with the proper
            working of the Site or the Services; (m) take any action that
            imposes, or may impose in our sole discretion, an unreasonable or
            disproportionately large load on our IT infrastructure; (n) modify,
            adapt, translate, or reverse engineer any portion of the Site or the
            Services; or (o) use the Site or the Services, intentionally or
            unintentionally, to violate any applicable international, national,
            federal, state, provincial, or local law or regulation, including,
            but not limited to, Fair Housing laws and regulations.
          </li>
        </ul>
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">3. ADDITIONAL REQUIREMENTS.</span>
        Certain aspects of the Services may be subject to additional
        requirements, guidelines, other technical and non-technical
        specifications, or other rules or policies in addition to those set
        forth in these Terms (the "Additional Requirements"). In the event of a
        conflict between the Additional Requirements and these Terms, the
        Additional Requirements shall take precedence.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">4. MODIFICATIONS.</span>
        Company may modify or update these Terms from time to time, in their
        sole discretion, and reserve the right at any time and from time to time
        to modify, suspend or discontinue, temporarily or permanently, the Site
        or any part thereof, or any or all of the Services, or any Site
        features, with or without notice and without liability to you. You agree
        that Company has no responsibility or liability for the failure of the
        Site and the deletion of other content maintained or transmitted by the
        Site. You further agree that Company shall not be liable to you or to
        any third party for any modification, suspension or discontinuance of
        the Site. Modifications to these Terms will be posted on the relevant
        area of the Site and will be effective immediately upon posting. You can
        review the most current version of the Terms at any time by clicking on
        the "Terms of Service" link located on webpages throughout the Site. You
        agree to review the Terms from time to time to ensure you are updated as
        to any modifications. By continuing to use the Site or Services
        following any such modification, you accept and agree to be bound by
        such modifications. IF ANY MODIFICATION IS NOT ACCEPTABLE TO YOU, YOUR
        SOLE AND EXCLUSIVE REMEDY AND RECOURSE IS TO DISCONTINUE USE OF THE SITE
        AND THE SERVICES.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">5. ACCOUNT REGISTRATION AND USE.</span>
        In order to use certain features of the Site or the Services, you will
        have to register and create a password-protected account ("Your
        Account") and/or submit property listings, lease agreements, rental
        terms, postings, messages, text, voice commands, images, photos, files,
        video, and other information, materials or documents (collectively,
        "Information and Material").
        <ul>
          <li className="my-2">
            <span className="font-bold mr-2">5.1 Your Account.</span>
            You agree to: (a) provide true, accurate, current, and complete
            information as prompted by the registration form; and (b) maintain
            and update such information to keep it true, accurate, current, and
            complete at all times. We reserve the right to delete Your Account
            and refuse any and all current or future use of the Site (or any
            portion thereof) without notice if you are found to have
            misrepresented your age, identity, or any other information
            submitted in connection with Your Account or if we have reasonable
            grounds to suspect that such information is untrue, inaccurate,
            incomplete or not current. You are responsible for maintaining the
            confidentiality of your password, your email address and Your
            Account, and are fully responsible for all activities that occur
            under your password and Your Account. You agree to: (i) immediately
            notify us of any unauthorized use of your password or account, or
            any other breach of security, (ii) immediately change your password
            if you become aware that Your Account has been compromised, (iii)
            ensure that you fully exit from Your Account at the end of each
            session. You agree and acknowledge that you will not allow others to
            utilize Your Account and that you will not disclose the password to
            Your Account to anyone. You will be solely responsible for
            safeguarding your password and also for any actions under your
            password and Account, whether authorized by you or not. If you lose
            control of your password, you may lose substantial control of your
            personal information and could potentially be subject to legally
            binding actions taken on your behalf. You further agree not to use
            anyone else’s password on the Site or attempt to gain access to the
            account of any other user. COMPANY CANNOT AND WILL NOT BE LIABLE FOR
            ANY LOSS OR DAMAGE ARISING FROM YOUR FAILURE TO COMPLY WITH THIS
            SECTION.
          </li>
          <li className="my-2">
            <span className="font-bold mr-2">
              5.2 Privacy Policy and Your Information and Material.
            </span>
            By submitting Information and Materials and in order for us to
            provide you with the Services, you hereby consent to our use and
            sharing of your Information and Materials as described in the
            applicable Privacy Policy, which is incorporated into these Terms by
            this reference. The Privacy Policy can be accessed by clicking on
            the "Privacy Policy" link located on webpages throughout the Site.
            In the event of a conflict between the applicable Privacy Policy and
            these Terms, the Privacy Policy shall take precedence. In addition,
            you hereby represent and warrant that your Information and
            Materials: (a) do not and will not, directly or indirectly, violate,
            infringe or breach any duty toward or rights of any person or
            entity, including without limitation any Fair Housing, copyright,
            trademark, service mark, trade secret, other intellectual property,
            publicity or privacy right; (b) are not fraudulent, misleading,
            hateful, tortious, defamatory, slanderous, libelous, abusive,
            violent, threatening, profane, vulgar or obscene; (c) do not harass
            others, promote bigotry, racism, hatred or harm against any
            individual or group, promote discrimination based on race, sex,
            religion, nationality, sexual orientation or age, or otherwise
            interfere with another party’s use of the Site or the Services; (d)
            do not promote illegal or harmful activities; and (e) are not
            illegal, unlawful or contrary to the international, national,
            federal, state, provincial, or local laws or regulations applicable
            to the User Materials where created, displayed or accessed.
          </li>
          <li className="my-2">
            <span className="font-bold mr-2">5.3 Renter Screening.</span>
            As part of the Services, Users may be permitted to submit
            information through the Site for the purpose of conducting a User
            background check or screening on behalf of a property manager or
            owner (a "Screening"). Information that you submit through the Site
            for the purpose of such Screening shall be treated in accordance
            with the Privacy Policy. Your submission of the information
            requested for a Screening shall constitute your consent to the
            Screening process. Screenings also may be governed by other
            Additional Requirements as may be disclosed to you in connection
            with the Screening. You acknowledge that you will address any issues
            or concerns with any Screenings, including the results of any
            Screenings, by contacting the appropriate property manager or owner,
            or as otherwise permitted under the Additional Requirements
            applicable to the Screening or as otherwise required by law.
          </li>
          <li className="my-2">
            <span className="font-bold mr-2">5.4 Payments.</span>
            Users may take advantage of certain Services that have a charge
            associated with them such as screening services, lease execution
            fees, and the like, that are imposed by Company or its affiliate,
            Company or such affiliate may collect these fees directly from Users
            as provided by the Site or the Services. You acknowledge these fees
            are subject to change.
            <br />
            Services-specific terms may set out further terms applying to such
            payments (including in relation to refunds (if any), billing
            arrangements and any consequences of failing to make timely
            payments). Application fees are non-refundable, even if an
            application is denied, except to the extent otherwise required by
            applicable law. You must comply with all such terms in relation to
            such payments by you.
            <br />
            By providing your card or bank information, you are representing
            that you are authorized to use this card or bank account for
            payments for rental deposits, rental payments, or any other services
            or transactions for services provided Company or its affiliate. If
            you are making a one-time payment, your card or bank information
            will not be stored after completion of the transaction, but any
            other personal information provided in connection with the
            transaction will be stored. If you are enrolling in recurring
            payments, you authorize Company’s electronic payment vendor, AdYen,
            to store your card or bank information to process your recurring
            payments. To access AdYen’s terms and conditions, please visit:
            <a
              href="https://www.adyen.com/legal/terms-and-conditions"
              className="link link-primary mx-1"
              target="_blank"
            >
              https://www.adyen.com/legal/terms-and-conditions
            </a>
            You are responsible for keeping your card or bank information up to
            date. If your card or bank information changes, you agree to
            promptly update your information. Company will continue to store
            your card or bank information until you delete your information or
            you cancel recurring payments. For more information about how we
            store and use your card, bank or other personal information, please
            see our Privacy Policy.
          </li>
          <li className="my-2">
            <span className="font-bold mr-2">5.5 Electronic Signatures.</span>
            If you choose to use any electronic signature execution
            functionality that may be made available on the Site, you
            understand, acknowledge and agree that you have carefully reviewed
            any disclosure relating to use of your electronic signature to
            execute documents and will not execute such documents with your
            electronic signature without providing your consent to use your
            electronic signature. You agree that you will rely on your own legal
            counsel to determine the sufficiency of the electronic signature
            execution of the documents and their enforceability and that Company
            makes no warranty or other representation with respect to the
            sufficiency of the electronic signature execution of the documents
            under applicable international, national, federal, state, provincial
            or local laws or regulations.
          </li>
          <li className="my-2">
            <span className="font-bold mr-2">
              5.6 IDENTITY VERIFICATION SERVICES.
            </span>
            You acknowledge that by using identity verification services, you
            give your express written consent to, if applicable: (i) send and
            receive text messages associated with the identity verification
            services, including text messages to and from third-parties that
            provide of document verification services; and (ii) have your
            "selfie" image used in the document and identity verification
            process. By providing a "selfie" image or an image of your
            identification documents, you agree that the images may be scanned
            and compared to your identification documents for authentication
            purposes.
          </li>
        </ul>
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">6. COMPANY’S RIGHTS.</span>
        You acknowledge that Company has the right to investigate and prosecute
        violations of these Terms, including intellectual property, publicity
        and privacy rights infringement and Site security issues, to the fullest
        extent of the law. Company may involve and cooperate with law
        enforcement authorities in prosecuting users who violate these Terms.
        You acknowledge that Company has no obligation to monitor your access to
        or use of the Site or the Services, but have the right to do so for the
        purpose of operating the Site, to ensure your compliance with these
        Terms or to comply with applicable law or the order or requirement of a
        court, administrative agency or other governmental body.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">7. SITE CONTENT GENERALLY.</span>
        It is solely your responsibility to evaluate the accuracy, completeness,
        and usefulness of all opinions, advice, statements, representations,
        services, and other information provided through the Site. Company does
        not endorse or represent the reliability, accuracy or quality of any
        information, goods, services or products displayed or advertised on the
        Site. Company makes no representations or warranties, express or
        implied, with respect to the information provided on this Site.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">
          8. THIRD-PARTY LINKS, PRODUCTS AND SERVICES.
        </span>
        The Site may contain links or voice accessibility to third-party
        websites or resources. Access to such third-party websites, services or
        resources are included solely for the convenience of Users, and do not
        constitute any endorsement or approval by Company of the third-parties,
        anyone sponsoring these sites or their products or services, or the
        products or services themselves. Company makes no representations or
        warranties, express or implied, with respect to the information provided
        on any third-party website or service which may be accessed from the
        Site, including any representations or warranties as to accuracy or
        completeness. Because Company has no control over third-party websites,
        resources, products or services, you acknowledge and agree that Company
        is not responsible or liable for, and does not endorse, the
        availability, accuracy, completeness or authenticity of information
        available through such websites, resources, products or services, your
        use or your exchange of any information with such websites or services,
        or the content, statements, representations, advertising, products,
        properties, services or other materials available on such third-party
        sites. You acknowledge and agree that Company shall not be responsible
        or liable, directly or indirectly, for any damage or loss caused or
        alleged to be caused in connection with your use or reliance on any such
        content, information, goods, or services available on or through any
        such site or resource. If you decide to access any such third-party
        websites, products, resources or services, or to transact with any such
        third-party for their products, properties or services, you do so
        entirely at your own risk. By leaving the Site, you may be subject to
        the terms and conditions and the privacy policies or other terms and
        conditions of such third-party websites.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">9. OWNERSHIP.</span>
        You acknowledge and agree that the Site and the Services use and contain
        intellectual property, and proprietary and confidential technology owned
        by or licensed to Company, and protected by applicable intellectual
        property and other laws and international treaties, as well as other
        intellectual property, including without limitation, information, data,
        text, music, sound, photographs, graphics, video, messages, tags, or
        other materials owned by or licensed to us, and protected by applicable
        intellectual property and other laws and international treaties
        (collectively, "Company IP"). All rights reserved. You agree not to
        reproduce, copy, display, store, perform, re-post, publish, transmit,
        distribute, sell, offer for sale, license, modify, create derivative
        works, or otherwise use or exploit for any commercial purposes any or
        all of the Company IP, the Site or access to the Site in any way without
        the prior written permission of Company. You must abide by all copyright
        notices, information, or restrictions contained in or attached to any
        Company IP. All trademarks are the property of their respective owners.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">10. INDEMNITY.</span>
        You agree to indemnify, defend and hold Company and their respective
        officers, directors, employees, shareholders, successors, agents,
        affiliates, subsidiaries and relevant third parties including
        advertisers, distribution partners, referral partners, service
        providers, licensors, licensees, consultants and contractors
        (collectively the "Indemnified Parties") harmless from and against any
        claims, liabilities, losses, costs, damages or expenses including
        reasonable attorneys’ fees and costs, directly or indirectly, arising
        out of or in any way relating to: (a) your negligence or misconduct; (b)
        your information or material contributed to or submitted through the
        Site or the Services, including without limitation information
        associated with Your Account; (c) your conduct, including your use of
        the Site and the Services; (d) your connection to the Site; (e) any
        violation or breach of these Terms; (f) any violation or infringement of
        any intellectual property, privacy, publicity, confidentiality or
        proprietary rights of any third-party as a result of your use of the
        Site or Services; or [(g) your use of the electronic signature lease
        execution functionality of the Site, including without limitation, the
        sufficiency of an electronic signature or the enforceability of an
        electronically signed lease] (collectively, the "Claims"). You are
        solely responsible for defending any such Claims, and for payment of
        losses, costs, damages or expenses resulting from the foregoing to both
        a third party and to the Indemnified Parties. Company shall have the
        right, in its sole discretion, to select its own legal counsel to defend
        themselves from any Claims (but by doing so shall not excuse your
        indemnity obligations) and you shall be solely responsible for the
        payment of all of Company’s reasonable attorneys’ fees incurred in
        connection therewith. You shall notify Company immediately if you become
        aware of any actual or potential claims, suits, actions, allegations or
        charges that could affect yours or Company’s ability to fully perform
        their respective duties or to exercise its rights under these Terms. You
        shall not, without the prior written approval of Company, settle,
        dispose or enter into any proposed settlement or resolution of any Claim
        (whether having been finally adjudicated or otherwise) brought against
        you, if such settlement or resolution results in any obligation or
        liability for Company.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">
          11. DISCLAIMER OF WARRANTIES. YOU EXPRESSLY UNDERSTAND AND AGREE:
        </span>
        <ul>
          <li className="my-2">
            11.1 YOUR USE OF THE SITE AND THE SERVICES IS AT YOUR SOLE RISK. THE
            SITE AND THE SERVICES AND ALL OTHER MATERIALS, INFORMATION,
            PRODUCTS, AND SERVICES INCLUDED THEREIN, ARE PROVIDED ON AN "AS IS"
            AND "AS AVAILABLE" BASIS WITHOUT WARRANTIES OF ANY KIND. WITH
            RESPECT TO THE SITE AND INFORMATION AND MATERIAL IN THE SITE,
            COMPANY EXPRESSLY DISCLAIMS ALL WARRANTIES AND REPRESENTATIONS OF
            ANY KIND, EXPRESS, IMPLIED OR STATUTORY, INCLUDING WITHOUT
            LIMITATION THE WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE, NON-INFRINGEMENT, COURSE OF DEALING OR COURSE OF
            PERFORMANCE.
          </li>
          <li className="my-2">
            11.2 COMPANY MAKES NO REPRESENTATION OR WARRANTY: (A) REGARDING THE
            SECURITY, ACCURACY, RELIABILITY, COMPLETENESS, TIMELINESS AND
            PERFORMANCE OF THE SITE OR THE SERVICES; (B) REGARDING THE SERVICES,
            ADVICE, INFORMATION OR LINKS OBTAINED THROUGH THE SITE; (C) THAT THE
            SITE OR THE SERVICES, OR ANY INFORMATION AND MATERIALS THEREIN, WILL
            MEET YOUR REQUIREMENTS; (D) THAT THE SITE OR THE SERVICES, OR ANY
            FUNCTIONS CONTAINED IN THE SITE, WILL BE ERROR-FREE, SECURE, TIMELY,
            OR UNINTERRUPTED; (E) THAT THE RESULTS THAT MAY BE OBTAINED FROM THE
            USE OF THE SITE OR INFORMATION AND MATERIALS THEREIN WILL BE
            ACCURATE, RELIABLE, OR AVAILABLE, (F) THAT ANY ERRORS IN THE SITE OR
            INFORMATION OR MATERIALS THEREIN WILL BE CORRECTED; OR (G) THAT THE
            SITE AND ITS CONTENTS AND SERVER THAT MAKES THE SITE AVAILABLE ARE
            FREE OF ANY VIRUSES OR OTHER HARMFUL COMPONENTS.
          </li>
          <li className="my-2">
            11.3 ANY MATERIAL, INFORMATION, PRODUCTS OR SERVICES DOWNLOADED OR
            OTHERWISE OBTAINED THROUGH YOUR USE OF THE SITE IS DONE AT YOUR OWN
            DISCRETION AND RISK AND THAT YOU WILL BE SOLELY RESPONSIBLE FOR ANY
            DAMAGE TO YOUR COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE
            DOWNLOAD OF ANY SUCH MATERIAL.
          </li>
          <li className="my-2">
            11.4 NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY
            YOU FROM COMPANY OR FROM YOUR USE OF THE SITE OR SERVICES, SHALL
            CREATE ANY REPRESENTATION OR WARRANTY NOT EXPRESSLY STATED IN THESE
            TERMS.
          </li>
          <li className="my-2">
            11.5 SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN
            REPRESENTATIONS OR WARRANTIES. ACCORDINGLY, SOME OF THE ABOVE
            LIMITATIONS MAY NOT APPLY TO YOU.
          </li>
        </ul>
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">12. LIMITATION OF LIABILITY.</span>
        <ul>
          <li className="my-2">
            12.1 COMPANY AND ITS OFFICERS, DIRECTORS, EMPLOYEES, SHAREHOLDERS,
            SUCCESSORS, AGENTS, AFFILIATES, SUBSIDIARIES AND RELEVANT THIRD
            PARTIES INCLUDING ADVERTISERS, DISTRIBUTION PARTNERS, REFERRAL
            PARTNERS, SERVICE PROVIDERS, LICENSORS, LICENSEES, CONSULTANTS AND
            CONTRACTORS (COLLECTIVELY THE "PARTIES") WILL NOT BE LIABLE FOR:
            <ul>
              <li className="my-2">
                A. ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL,
                EXEMPLARY OR PUNITIVE DAMAGES (INCLUDING LOSS OF USE, DATA OR
                PROFITS, COST OF PROCURING SUBSTITUTE PRODUCTS OR BUSINESS
                INTERRUPTION), WHETHER BASED ON CONTRACT, WARRANTY, TORT
                (INCLUDING NEGLIGENCE), STRICT LIABILITY OR ANY OTHER LEGAL
                THEORY, ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT,
                YOUR ACCESS AND USE OF OR INABILITY TO ACCESS OR USE THE SITE OR
                THE SERVICES, ANY MATERIALS AVAILABLE TO YOU FROM OR THROUGH THE
                SITE (INCLUDING SUCH DAMAGES INCURRED BY THIRD PARTIES), WHETHER
                THE DAMAGES ARE FORESEEABLE AND WHETHER OR NOT THE INDEMNIFIED
                PARTIES, OR ANY OF THEM, HAVE BEEN ADVISED OF THE POSSIBILITY OF
                SUCH DAMAGES;
              </li>
              <li className="my-2">
                B. THE CONTENTS OF ANY COMMUNICATION, MESSAGE, OR INFORMATION
                POSTED BY YOU OR OTHER THIRD PARTIES;
              </li>
              <li className="my-2">
                C. THE CONTENT, SERVICES OR INFORMATION PROVIDED BY ANY WEBSITE
                PURPORTING TO BE OPERATED BY COMPANY OR THEIR AFFILIATES, BUT
                NOT ACTUALLY AFFILIATED WITH, CONTROLLED, OWNED, OR OPERATED BY
                COMPANY;
              </li>
              <li className="my-2">
                D. THE CONTENT OF ANY WEBSITE NOT CONTROLLED, OWNED, OR OPERATED
                BY COMPANY THAT IS ACCESSED FROM OR LINKED TO THIS SITE; AND/OR
              </li>
              <li className="my-2">
                E. ANY DAMAGES OR INJURY CAUSED BY, INCLUDING BUT NOT LIMITED
                TO, ANY FAILURE OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION,
                DEFECT, DELAY IN OPERATION OF TRANSMISSION, COMPUTER VIRUS, OR
                LINE FAILURE.
              </li>
            </ul>
          </li>
          <li className="my-2">
            12.2 You acknowledge that the limitations set forth above are an
            essential basis of the bargain and of the allocation of risks
            between the parties. Some states or jurisdictions do not allow the
            limitation or exclusion of liability for incidental or consequential
            damages. Accordingly, some of the above limitations may not apply to
            you. If you are dissatisfied with any portion of the Site, or with
            any of these Terms, your sole and exclusive remedy is to discontinue
            use of the Site and Services.
          </li>
        </ul>
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">13. ENFORCEMENT.</span>
        Company does not assume responsibility to you or others for any failure
        by Company to enforce the provisions contained in the Terms.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">14. TERMINATION.</span>
        You agree that we, in our sole discretion and with or without notice,
        may terminate your use of the Site or any part thereof, or any or all of
        the Services, for any reason, including without limitation, for lack of
        use by you or if we believe that you have violated or acted
        inconsistently with the letter or spirit of the Terms. We may also in
        our sole discretion and at any time discontinue providing the Site, or
        any part thereof, or any or all of the Services with or without notice.
        You agree that any termination of your access to the Site under any
        provision of the Terms may be effected without prior notice, and
        acknowledge and agree that Company may immediately bar any further
        access to the Site. Further, you agree that Company shall not be liable
        to you or any third party for any termination of your access to the Site
        or the Services.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">15. AUTHORITY.</span>
        You hereby represent and warrant to Company that: (a) you have all the
        requisite power and authority, corporate or otherwise, to enter into the
        binding contract created by these Terms, conduct yourself and your
        business and to execute, deliver, and perform all of your obligations
        under this Agreement; (b) you have the right to submit and use your
        Information and Materials in the manner you have done so to or through
        the Site and/or through Your Account; (c) you have the right to grant
        the licenses granted under these Terms; (d) your performance under these
        Terms and/or the rights granted herein do not and will not conflict with
        or result in a breach or violation of any of the terms or provisions, or
        constitute a default under any contract or agreement, to which you are
        currently bound or will become bound in the future; and (e) your
        performance under these Terms will comply with all applicable laws,
        rules and regulations (including, without limitation, export control,
        privacy and obscenity laws), domestic or foreign.
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">16. Reserved.</span>
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">17. INTERACTIVE AREAS.</span>
        <ul>
          <li className="my-2">
            <span className="font-bold mr-2">
              17.1 Use of Interactive Areas.
            </span>
            On the Site and/or as part of the Services, we may provide areas
            that allow for User interaction, including bulletin boards, chat
            areas, forums, blogs, instant messaging, frequently asked questions,
            or other message and communications features (the "Interactive
            Areas") for posting user feedback, comments, messages or other input
            ("Comments"). You acknowledge that all Interactive Areas are public
            and not private and that any information or content, including
            Information and Material, that you post to an Interactive Area may
            be read by others and that Company has no obligation to protect such
            information. Company recommends that you do not post or otherwise
            disseminate any personally identifiable information in the
            Interactive Area. Additionally, you agree to post only Comments that
            are proper, lawful, and related to the particular discussion or the
            Interactive Area itself. Without limitation, you may not post
            Comments or engage in any other activity on the Site that:
          </li>
          <li className="my-2">
            <ul>
              <li className="my-2">
                A. defames, threatens, abuses or otherwise violates the legal
                rights of others;
              </li>
              <li className="my-2">
                B. is harmful to children, profane, obscene, indecent or
                racially or ethnically offensive;
              </li>
              <li className="my-2">
                C. infringes another’s rights to intellectual property,
                publicity, or privacy;
              </li>
              <li className="my-2">
                D. collects or stores personal information about other Site
                users;
              </li>
              <li className="my-2">
                E. contains advertisements, promotions, commercial
                solicitations, contests or surveys (unless you have our written
                consent to do so);
              </li>
              <li className="my-2">
                F. contains, transmits or disseminates spam, chain letters, or
                information intended to assist in the placement of a bet or
                wager;
              </li>
              <li className="my-2">
                G. contains, transmits or disseminates viruses, corrupted files,
                or any other similar software or programs that may damage or
                adversely affect the operation of another’s computer, the Site,
                or any software, hardware or other related equipment;
              </li>
              <li className="my-2">
                H. disrupts or otherwise interferes with the Site or the
                networks or servers used by Company;
              </li>
              <li className="my-2">
                I. impersonates any person or entity or misrepresent your
                connection or affiliation with a person or entity; or
              </li>
              <li className="my-2">J. constitutes illegal activity.</li>
            </ul>
          </li>
          <li className="my-2">
            <span className="font-bold mr-2">
              17.2 Submissions to Interactive Areas.
            </span>
            You understand and acknowledge that, subject and pursuant to the
            licenses set forth hereunder, we may display your Comments on the
            Site and use them for other marketing and business activities. In
            addition, we reserve the right in our sole discretion to reject use
            of Comments, delete Comments from the Site for any reason, and edit
            Comments for both content and format. We further reserve the right
            to terminate your access to the Site or to any Interactive Area at
            any time without notice for any reason whatsoever. Company does not
            endorse or control the Comments or information found in any
            Interactive Area and, therefore, Company specifically disclaims any
            liability with regard to the Interactive Areas and any actions
            resulting from your participation in them.
          </li>
        </ul>
      </div>

      <div className="my-3">
        <span className="font-bold mr-2">18. GENERAL.</span>
        <ul>
          <li className="my-2">
            <span className="font-bold mr-2">18.1 Governing Law.</span>
            For all legal proceedings arising out of use of the Site and/or
            relating to the Terms, these Terms and the relationship between you
            and Company shall, irrespective of any choice of laws rules, be
            governed by and construed in accordance with the laws of the State
            in which the property is located. You and Company hereby irrevocably
            and unconditionally submit to the jurisdiction of courts located in
            the County in which the property is located or the court of
            competent jurisdiction closest thereto if no court of competent
            jurisdiction resides therein, and the parties consent to the
            personal jurisdiction of such courts and expressly waive any right
            they may otherwise have to cause any such action or proceeding to be
            brought or tried elsewhere. You and Company irrevocably waive, to
            the fullest extent permitted by law, any objection that you may now
            or hereafter have to the laying of the venue of any proceeding
            brought in any such court or any claim that a legal proceeding
            commenced in such court has been brought in an inconvenient forum.
          </li>
          <li className="my-2">
            <span className="font-bold mr-2">18.2 Assignment.</span>
            You may not assign or transfer this Agreement, in whole or in part,
            without the prior written consent of Company, which may be granted
            or withheld by Company in its their sole discretion. Any attempted
            assignment in violation of this Section will be null and void and of
            no force or effect. Company may assign this Agreement freely at any
            time without notice. Subject to the foregoing, this Agreement will
            bind and inure to the benefit of each party’s permitted successors
            and assigns.
          </li>
          <li className="my-2">
            <span className="font-bold mr-2">18.3 Waiver.</span>
            The failure to exercise or enforce any right or provision shall not
            affect Company’s right to exercise or enforce such right or
            provision at any time thereafter, nor shall a waiver of any breach
            or default of these Terms constitute a waiver of any subsequent
            breach or default or a waiver of the provision itself.
          </li>
          <li className="my-2">
            <span className="font-bold mr-2">18.4 Severability.</span>
            If any portion of these Terms is found by a court of competent
            jurisdiction to be invalid or unenforceable, the parties
            nevertheless agree that the court should endeavor to give effect to
            the parties’ intentions as reflected in such provision, and,
            notwithstanding such finding, the remaining provisions of these
            Terms shall remain in full force and effect.
          </li>
          <li className="my-2">
            <span className="font-bold mr-2">18.5 Entire Agreement. </span>
            These Terms, the terms incorporated herein, and any other terms
            agreed to in writing by the parties or by way of your use of the
            Site or the Services shall constitute the entire and exclusive
            understanding and agreement between you and Company regarding this
            subject matter, and shall supersede any and all prior or
            contemporaneous representations or understandings relating to this
            subject matter.
          </li>
          <li className="my-2">
            <span className="font-bold mr-2">18.6 Time Limitation.</span>
            You agree that regardless of any statute or law to the contrary, any
            claim or cause of action arising out of or related to the Terms or
            use of the Site must be filed within 1 year after such claim or
            cause of action arose or be forever barred.
          </li>
        </ul>
      </div>
      <div className="my-3">Updated July 28, 2022</div>
    </div>
  )
}

export default TermsOfService
